import axios from 'axios';
import qs from 'qs';
import { setupCache } from 'axios-cache-adapter';
import config from '../../config';

let api;

let token;


export const setAuthToken = (_token) => {
  token = _token
  axios.defaults.headers.common['Authorization'] = _token;
};

export const getAuthToken = () => token;

//init
(() => {
  const isDev = config.isDevelopment;
  const cache = setupCache({
    maxAge: 10 * 1000
  });

  //TODO - timeout ?
  api = axios.create({
    adapter: cache.adapter,
    debug: isDev,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    },
    baseURL: config.apiUrl
  });

})();


export default api;
